module.exports = __webpack_public_path__ + "media/assets/images/campaigns/youtube-ftc-bb7524586e1d32425b4d9dcbb4dbc750.png";